<app-kpi-widget
  [title]="title"
  [icon]="'ph-duotone ph-circle-dashed'"
  [isLoading]="isLoading"
  [totalValue]="value"
  [percentageDifferenceEnabled]="false"
  [hasError]="hasError"
  [errorMessage]="errorMessage"
  [valueFormatter]="formatValue.bind(this)"
  [widgetDisabled]="true"
  [isImageIcon]="false"
  [dropdownEnabled]="false"
  [hasFooter]="false"
  [hasValueOnly]="true"
  [hasDifference]="false"
  [isUptrendPositive]="true">
</app-kpi-widget>